/* ProTech Space — Theme JS
   Carrinho 100% sincronizado com Shopify AJAX API */

// ── ADD TO CART ───────────────────────────────────────────────────────────────
function addToCart(variantId, title, price, image, qty) {
  qty = qty || parseInt(document.getElementById('qty')?.value || 1);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(r => r.json())
  .then(() => refreshCart())
  .then(() => {
    showToast('✓ ' + title + ' adicionado ao carrinho');
    openCart();
  })
  .catch(() => showToast('Erro ao adicionar ao carrinho'));
}

// ── REMOVE FROM CART ──────────────────────────────────────────────────────────
function removeFromCart(variantId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  })
  .then(r => r.json())
  .then(() => refreshCart())
  .catch(() => refreshCart());
}

// ── CHANGE QUANTITY ───────────────────────────────────────────────────────────
function changeItemQty(variantId, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(r => r.json())
  .then(() => refreshCart())
  .catch(() => refreshCart());
}

// ── REFRESH CART FROM SHOPIFY ────────────────────────────────────────────────
function refreshCart() {
  return fetch('/cart.js')
    .then(r => r.json())
    .then(data => {
      updateCartCount(data.item_count);
      renderCartItems(data);
      return data;
    });
}

// ── UPDATE COUNTER ────────────────────────────────────────────────────────────
function updateCartCount(count) {
  const el = document.getElementById('cart-count');
  if (!el) return;
  el.textContent = count;
  el.style.display = count > 0 ? '' : 'none';
  // Drawer header count
  const dc = document.getElementById('drawer-count');
  if (dc) dc.textContent = count > 0 ? '(' + count + ')' : '';
}

// ── RENDER CART ITEMS ─────────────────────────────────────────────────────────
function renderCartItems(data) {
  const container = document.getElementById('cart-items');
  const totalEl   = document.getElementById('cart-total-price');
  const checkoutBtn = document.getElementById('drawer-checkout-btn');
  if (!container) return;

  if (!data || !data.items || data.items.length === 0) {
    container.innerHTML = `
      <div class="cart-empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/>
        </svg>
        <p>O teu carrinho está vazio</p>
      </div>`;
    if (totalEl) totalEl.textContent = '0,00 €';
    if (checkoutBtn) checkoutBtn.style.opacity = '0.4';
    return;
  }

  if (checkoutBtn) checkoutBtn.style.opacity = '1';

  container.innerHTML = data.items.map(item => {
    const price   = (item.final_line_price / 100).toFixed(2).replace('.', ',') + ' €';
    const imgSrc  = item.image ? item.image.replace('http:', 'https:') : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return `
      <div class="cart-item" data-variant-id="${item.variant_id}" data-qty="${item.quantity}">
        <div class="cart-item__img">
          ${imgSrc ? `<img src="${imgSrc}" alt="${escHtml(item.title)}" loading="lazy">` : ''}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__name">${escHtml(item.product_title)}</div>
          ${variant ? `<div class="cart-item__variant">${escHtml(variant)}</div>` : ''}
          <div class="cart-item__price">${price}</div>
          <div class="cart-item__qty-row">
            <button class="cart-item__qty-btn" data-action="decrease" aria-label="Diminuir">−</button>
            <span class="cart-item__qty-num">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-action="increase" aria-label="Aumentar">+</button>
          </div>
        </div>
        <button class="cart-item__remove" data-action="remove" aria-label="Remover">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>`;
  }).join('');

  if (totalEl) {
    totalEl.textContent = (data.total_price / 100).toFixed(2).replace('.', ',') + ' €';
  }
}

// ── CART DRAWER ───────────────────────────────────────────────────────────────
function openCart() {
  refreshCart().then(() => {
    document.getElementById('cart-drawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

// ── TOAST ─────────────────────────────────────────────────────────────────────
function showToast(message) {
  const container = document.getElementById('toast-container');
  if (!container) return;
  const toast = document.createElement('div');
  toast.className = 'toast toast--success';
  toast.textContent = message;
  container.appendChild(toast);
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(8px)';
    toast.style.transition = 'all 0.3s';
    setTimeout(() => toast.remove(), 300);
  }, 2800);
}

function escHtml(s) {
  return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
}

// ── COLLECTION SORT/FILTER ────────────────────────────────────────────────────
function sortProducts(value) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', value.replace('-', '_'));
  window.location.href = url.toString();
}
function clearFilters() { window.location.href = window.location.pathname; }
function filterAvailable(checked) {
  const url = new URL(window.location.href);
  checked ? url.searchParams.set('filter.p.m.availability', '1')
          : url.searchParams.delete('filter.p.m.availability');
  window.location.href = url.toString();
}

// ── INIT ──────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  // Sync cart count on load
  fetch('/cart.js').then(r => r.json()).then(data => {
    updateCartCount(data.item_count);
  }).catch(() => {});

  // Close drawer on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  // Event delegation for cart item buttons (works with dynamic innerHTML)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;

    const item    = btn.closest('.cart-item');
    if (!item) return;

    const variantId = item.dataset.variantId;
    const qty       = parseInt(item.dataset.qty) || 1;
    const action    = btn.dataset.action;

    if (action === 'remove') {
      removeFromCart(variantId);
    } else if (action === 'decrease') {
      if (qty <= 1) removeFromCart(variantId);
      else changeItemQty(variantId, qty - 1);
    } else if (action === 'increase') {
      changeItemQty(variantId, qty + 1);
    }
  });
});
